module.exports = __webpack_public_path__ + "img/visibility-off.cb731888.svg";